import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { getFunctions, provideFunctions } from '@angular/fire/functions';
import { getStorage, provideStorage } from '@angular/fire/storage';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { loadingInterceptor } from './core/interceptor/loading.interceptor';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
     provideRouter(routes),
     provideHttpClient(withInterceptors([loadingInterceptor])),

     importProvidersFrom(RecaptchaV3Module),

    // 👇 Tu clave pública de reCAPTCHA v3
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6LccKBosAAAAAHfyPOpbkb2BthoEUyPS-9W6zoEL' // <-- cámbiala por la de Google
    },

     provideFirebaseApp(() => initializeApp({
      apiKey: "AIzaSyARZN_Qb7PZXtDF3oywsgPL_ygHZB_mksM",
      authDomain: "qhse-energy.firebaseapp.com",
      projectId: "qhse-energy",
      storageBucket: "qhse-energy.firebasestorage.app",
      messagingSenderId: "814288298822",
      appId: "1:814288298822:web:d037cb98f4aee0e6677b47",
      measurementId: "G-XDSW86XJYS"
    })),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideDatabase(() => getDatabase()),
    provideFunctions(() => getFunctions()),
    provideStorage(() => getStorage()),
    provideAuth(() => getAuth()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false || 'none'
        }
        // Opcional: puedes configurar cssLayer, darkModeSelector, prefix...
      }
    })
  ]
};
